import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Link, Redirect } from 'react-router-dom';
import SignaturePad from 'signature_pad';
import getCanvas from 'html2canvas';
import PropTypes from 'prop-types';
import get from 'lodash/get';


import { signUpSignature, SIGN_UP_BACKUP_WITHHOLDING } from '../../actions';
import { bankLinkSignature } from '../../actions/bankLinks';
import Button from '../Button';
import { MIN_WIDTH } from '../Layout/enums';
import closeX from '../../assets/images/close_not.svg';

import './styles.css';


const SIGNATURE_FONT_STYLES = ['Satisfy', 'Parisienne', 'Mrs Saint Delafield'];

export const SIGNATURE_TYPE = Object.freeze({ SIGN_UP: 0, BANK_LINK: 1, OFFER_INVEST: 2 });


let $canvas;
let Signature;

function initializeCanvas(el) {
  if (el) {
    $canvas = el;
    Signature = new SignaturePad($canvas);
  }
}

function resetCanvas() {
  if ($canvas) {
    initializeCanvas($canvas);
  }
}

function saveSignature() {
  if (Signature.isEmpty()) {
    return false;
  }
  const image = Signature.toDataURL();
  Signature.off();
  return image;
}

const SignUpDisclaimer = ({
  backupWithholding,
  onBackupWithholdingChange,
}) => (
  <div styleName="disclaimerText">
    <h2>Customer Agreement</h2>
    <p>By signing below and clicking &ldquo;Create Account&ldquo;, I acknowledge and agree that:</p>
    <ol>
      <li>
        I am opening a brokerage account with Folio Investments, Inc. (&ldquo;Folio&rdquo;),
        Cambria Capital, LLC dba My IPO’s (&ldquo;My IPO&rdquo;) chosen custodian.
      </li>
      <li>
        I am the Primary Account Holder listed below.
      </li>
      <li>
        I am a U.S. Person, and the tax identification number provided is my true taxpayer
        identification number.
      </li>
      <li>
      I am not subject to backup withholding as a result of my failure to report all interest
      and dividends, or the Internal Revenue Service (IRS) has notified me that I am no
      longer subject to backup withholding.
        <div styleName="backupWithholdingQuestion">
          <input
            type="checkbox"
            id="backup-withholding"
            checked={backupWithholding}
            onChange={e => onBackupWithholdingChange(e.target.checked)}
          />
          <label htmlFor="backup-withholding">
            Check here ONLY if you are subject to backup withholding.
          </label>
        </div>
      </li>
      <li>
        I agree that My IPO and Folio do not recommend any securities or investments, do not
        question, investigate, analyze, monitor, or otherwise evaluate any of the investment
        decisions of any investor or the decisions or directions that may be provided by any
        individual or entity with authority over this account, nor do they determine, disclose
        or research risk factors that may be applicable to investing in securities.
      </li>
      <li>
        I have received, read, and agree to the terms and conditions set forth in&nbsp;
        <Link to="/customer-agreements">
          the My IPO and Folio customer agreements.
        </Link>
      </li>
      <li>
        My IPO and Folio will share your personal and financial information
        between themselves as needed to service your account and consistent with each firm’s
        privacy policy.
      </li>
      <li>
        Here you can find <a href="/static/docs/Cambria_Capital_Form_CRS.pdf" target="_blank">Form CRS</a>.
      </li>
    </ol>
    <p style={{ fontWeight: 'bold', marginBottom: '1em' }}>
      By signing below you agree to a pre-dispute&nbsp;
      <Link to="/arbitration-clauses">
        arbitration clause
      </Link>
      &nbsp;located in the My IPO and Folio customer agreements.
    </p>
    <p style={{ fontWeight: 'bold', marginBottom: '1em' }}>
      The Internal Revenue Service does not require consent to any provision of this document
      other than the certifications required to avoid backup withholding.
    </p>
  </div>
);

const AddBankLinkDisclaimer = () => (
  <div styleName="disclaimerText">
    By entering your bank account information and clicking &quot;Add
    Link&quot;, you are authorizing Cambria Capital, LLC dba My IPO
    (&quot;My IPO&quot;) to communicate your bank account information
    to Folio Investments, Inc (&quot;Folio&quot;). You also authorize
    My IPO to make transfers between this bank account and your
    account that is custodied at Folio.
    <br />
    <br />
    <strong>
      Bank Link Agreement
    </strong>
    <br />
    <br />
      By signing below, I acknowledge and agree that:
    <br />
      &emsp;1.  I am the Primary Account Holder listed below.
    <br />
      &emsp;2.  I have received and read the terms and conditions set forth in &nbsp;
      <Link to={{ pathname: '/customer-agreements', state: { isBankLink: true, previousLink: window.location.pathname } }}>
        customer agreements.
      </Link>
    <br />
      &emsp;3.  My IPO and Folio Client will share your personal and financial
      information between themselves as needed to service your account and consistent
      with each firm’s privacy policy.
  </div>
);


class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      selectedSignature: '',
      showSignaturePad: false,
      disabled: false,
    };

    this.save = this.save.bind(this);
    this.setPreviewSignature = this.setPreviewSignature.bind(this);
    this.setRef = this.setRef.bind(this);
    this.toggleSignaturePad = this.toggleSignaturePad.bind(this);
    this.updateSelected = this.updateSelected.bind(this);
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  setPreviewSignature() {
    const signature = saveSignature();
    this.setState({
      signaturePreview: signature,
      selectedSignature: 'drawn',
    });
    this.toggleSignaturePad();
  }

  setRef(el) {
    this.setState({ signatureRef: el });
  }

  toggleSignaturePad() {
    this.setState({ showSignaturePad: !this.state.showSignaturePad });
  }

  updateSelected(selectedStyle) {
    this.setState({ selectedSignature: selectedStyle });
  }

  save() {
    //
    // signature ref is declared when a signature option is displayed
    // in the selected state
    //
    if (!this.state.signatureRef) {
      this.setState({ error: 'You must select a signature to continue.' });
      return;
    }

    this.setState({ disabled: true });

    getCanvas(this.state.signatureRef)
      .then((canvas) => {
        const img = canvas.toDataURL();
        switch (this.props.signatureType) {
          case SIGNATURE_TYPE.SIGN_UP:
            this.props.saveImageSignup(img, 'PNG');
            break;
          case SIGNATURE_TYPE.BANK_LINK:
            this.props.saveImageBankLink(img, 'PNG');
            break;
          // no default
        }

        this.props.onNext();
      });
  }

  handleLeavePage = (e) => {
    const { isPersonalInfoPristine } = this.props;
    if (!isPersonalInfoPristine) {
      e.preventDefault();
      e.returnValue = '';
    }
  };

  render() {
    const {
      signatureType,
      identity,
      user,
    } = this.props;
    if (signatureType === SIGNATURE_TYPE.SIGN_UP && !('firstName' in identity)) {
      return <Redirect to="/login" push={false} />;
    }
    const { disabled } = this.state;
    const firstName = signatureType === SIGNATURE_TYPE.SIGN_UP ? identity.firstName :
      user.firstName;
    const lastName = signatureType === SIGNATURE_TYPE.SIGN_UP ? identity.lastName :
      user.lastName;
    const signaturePad = (
      <div styleName="signatureInputScreen">
        <div styleName="signatureInputForm">
          <div
            onClick={this.toggleSignaturePad}
            onKeyPress={this.toggleSignaturePad}
            role="button"
            styleName="closeSignatureInput"
            tabIndex={0}
          >
            <img src={closeX} alt="closeSignaturePad" />
          </div>
          <div styleName="drawSuggestion">
            Draw your signature
          </div>
          <div styleName="instructions">
            Use your mouse, tablet, or smartphone
          </div>
          <MediaQuery
            minWidth={MIN_WIDTH.DESK}
          >
            <canvas
              ref={initializeCanvas}
              width="640px"
              height="260px"
              styleName="drawingPad"
            />
          </MediaQuery>
          <MediaQuery
            maxWidth={MIN_WIDTH.DESK - 1}
            minWidth={MIN_WIDTH.TAB}
            orientation="portrait"
          >
            <canvas
              ref={initializeCanvas}
              width="640px"
              height="260px"
              styleName="drawingPad"
            />
          </MediaQuery>
          <MediaQuery
            maxWidth={MIN_WIDTH.DESK - 1}
            minWidth={MIN_WIDTH.TAB}
            orientation="landscape"
          >
            <canvas
              ref={initializeCanvas}
              width="525px"
              height="140px"
              styleName="drawingPad"
            />
          </MediaQuery>
          <MediaQuery
            maxWidth={MIN_WIDTH.TAB - 1}
          >
            <canvas
              ref={initializeCanvas}
              width="320px"
              height="130px"
              styleName="drawingPad"
            />
          </MediaQuery>
          <div styleName="signatureInputButtons">
            <div styleName="buttonWidthRestriction">
              <Button onClick={resetCanvas}>
                Clear signature
              </Button>
            </div>
            <div styleName="buttonWidthRestriction">
              <Button onClick={this.setPreviewSignature}>
                Save Signature
              </Button>
            </div>
          </div>
        </div>
      </div>
    );

    const signatureOptions = SIGNATURE_FONT_STYLES.map((fontStyle) => {
      const style = {
        width: '100%',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        paddingLeft: '14px',
        fontSize: '28px',
        fontFamily: `'${fontStyle}', cursive`,
        border: '1px solid #c2d6e9',
        borderRadius: '2px',
        backgroundColor: 'white',
        cursor: 'pointer',
        outline: 'none',
        ':focus': {
          outline: 'none',
        },
        ':active': {
          outline: 'none',
        },
      };

      let setSignatureReference = () => {};
      if (fontStyle === this.state.selectedSignature) {
        style.border = '1px solid #4a87c0';
        style.boxShadow = '0px 4px 8px 0px #DFE9F3';
        setSignatureReference = this.setRef;
      }

      return (
        <div
          key={fontStyle}
          ref={setSignatureReference}
          style={style}
          onClick={() => { this.updateSelected(fontStyle); }}
          onKeyPress={() => { this.updateSelected(fontStyle); }}
          role="option"
          tabIndex={0}
          aria-selected
        >
          { `${firstName} ${lastName}` }
        </div>
      );
    });

    if (this.state.signaturePreview) {
      const style = {
        width: '100%',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        paddingLeft: '14px',
        boxShadow: '0px 2px 4px 0px #DFE9F3',
        border: '1px solid #c2d6e9',
        borderRadius: '2px',
        backgroundColor: 'white',
        cursor: 'pointer',
        outline: 'none',
        ':focus': {
          outline: 'none',
        },
        ':active': {
          outline: 'none',
        },
      };

      let setSignatureReference = () => {};
      if (this.state.selectedSignature === 'drawn') {
        style.border = '1px solid #4a87c0';
        style.boxShadow = '0px 4px 8px 0px #DFE9F3';
        setSignatureReference = this.setRef;
      }

      const signaturePreview = (
        <div
          style={style}
          key="signaturePreview"
          onClick={() => { this.updateSelected('drawn'); }}
          onKeyPress={() => { this.updateSelected('drawn'); }}
          role="option"
          tabIndex={0}
          aria-selected
        >
          <img
            src={this.state.signaturePreview}
            alt="drawnSignature"
            styleName="signaturePreviewImage"
            ref={setSignatureReference}
          />
        </div>
      );

      signatureOptions.push(signaturePreview);
    }

    return (
      <div>
        {signatureType === SIGNATURE_TYPE.SIGN_UP ? (
          <SignUpDisclaimer
            backupWithholding={this.props.backupWithholding}
            onBackupWithholdingChange={this.props.signUpBackupWithholding}
          />
        ) : null}
        {signatureType === SIGNATURE_TYPE.BANK_LINK ?
          <AddBankLinkDisclaimer /> : null}
        <div styleName="breakLineSignature" />
        <div styleName="selectSignature">
          Please select a signature to use.
        </div>
        <div styleName="signatureOptions">
          { signatureOptions }
        </div>
        <div styleName="or">
          OR
        </div>
        <div
          onClick={this.toggleSignaturePad}
          onKeyPress={this.toggleSignaturePad}
          role="button"
          styleName="drawOption"
          tabIndex={0}
        >
          Draw your signature
        </div>
        <div styleName="selectSignatureError">
          { this.state.error }
        </div>
        {signatureType === SIGNATURE_TYPE.OFFER_INVEST ? null :
        <div styleName="submitButtonContainer">
          <Button
            disabled={disabled}
            onClick={this.save}
          >
            {signatureType === SIGNATURE_TYPE.SIGN_UP ? 'Create Account' : 'Add Link'}
          </Button>
        </div>
        }
        { this.state.showSignaturePad && signaturePad }
      </div>
    );
  }
}

Component.displayName = 'SignatureForm';

Component.propTypes = {
  signatureType: PropTypes.number,
};

Component.defaultProps = {
  signatureType: SIGNATURE_TYPE.SIGN_UP,
};

const mapStateToProps = state => ({
  identity: state.rrSignupForms.personalInfo.identity,
  backupWithholding: state.signUpInfo.backupWithholding || false,
  user: get(state, 'user.data', {}),
});

const mapDispatchToProps = dispatch => ({
  saveImageSignup: (img, type) => (dispatch(signUpSignature(img, type))),
  saveImageBankLink: (img, type) => (dispatch(bankLinkSignature(img, type))),
  signUpBackupWithholding: backupWithholding => dispatch({
    type: SIGN_UP_BACKUP_WITHHOLDING,
    backupWithholding,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/SignUp/Signature.js